export const Auth_SignUp_Loading = "auth/signup/loading";
export const Auth_SignUp_Error = "auth/signup/error";
export const Auth_SignUp_Success = "auth/signup/success";

export const Auth_LogIn_Loading = "auth/logIn/loading";
export const Auth_LogIn_Error = "auth/logIn/error";
export const Auth_LogIn_Success = "auth/logIn/success";

export const Auth_Logout = "auth/logout";